__turbopack_context__.v({
  "avatar": "ProfileAvatar-module-scss-module__bQ3fhW__avatar",
  "company": "ProfileAvatar-module-scss-module__bQ3fhW__company",
  "large": "ProfileAvatar-module-scss-module__bQ3fhW__large",
  "small": "ProfileAvatar-module-scss-module__bQ3fhW__small",
});
